import BackendConfigService from '../configs/backendConfigService'


class LoginService extends BackendConfigService {
    
    constructor(){
        let headers = {}
        super('/usuarios', headers)
    }

    jwt(login){
        return this.post('/jwt/', login)
    }
    
    
}

export default LoginService